import {
  GET_AGGR_GROUP_BY_TAGS_DATA_SUCCESS,
  GET_AGGR_TAGS_DATA,
  GET_AGGR_TAGS_DATA_ERROR,
  GET_AGGR_TAGS_DATA_SUCCESS,
  GET_API_DATA_BY_ID,
  GET_API_DATA_BY_ID_ERROR,
  GET_API_DATA_BY_ID_SUCCESS,
  GET_API_TIMINGS_DATA,
  GET_API_TIMINGS_DATA_ERROR,
  GET_API_TIMINGS_DATA_SUCCESS,
  EXPORT_API_TIMINGS_DATA,
  EXPORT_API_TIMINGS_DATA_SUCCESS,
  EXPORT_API_TIMINGS_DATA_ERROR,
  GET_PROFILING_TAGS,
  GET_PROFILING_TAGS_ERROR,
  GET_PROFILING_TAGS_SUCCESS,
  GET_DMS_LOGS_STREAMS,
  GET_DMS_LOGS_STREAMS_SUCCESS,
  GET_DMS_LOGS_STREAMS_ERROR,
  GET_DMS_STATS_DATA,
  GET_DMS_STATS_DATA_SUCCESS,
  GET_DMS_STATS_DATA_ERROR,
  GET_DMS_LOGS_DATA,
  GET_DMS_LOGS_DATA_SUCCESS,
  GET_DMS_LOGS_DATA_ERROR,
  GET_PRODUCTS_NAMES,
  GET_PRODUCTS_NAMES_SUCCESS,
  GET_PRODUCTS_NAMES_ERROR,
  GET_RULE_STATS,
  GET_RULE_STATS_SUCCESS,
  GET_RULE_STATS_ERROR,
  GET_RULE_NAMES,
  GET_RULE_NAMES_SUCCESS,
  GET_RULE_NAMES_ERROR,
  GET_RULE_LOGS,
  GET_RULE_LOGS_SUCCESS,
  GET_RULE_LOGS_ERROR,
  GET_ACCOUNTS_LIST_ERROR,
  GET_ACCOUNTS_LIST,
  GET_ACCOUNTS_LIST_SUCCESS,
  GET_RULE_LOG_DETAILS,
  GET_RULE_LOG_DETAILS_SUCCESS,
  GET_RULE_LOG_DETAILS_ERROR,
} from './actionTypes';

export const getProfilingTags = () => ({
  type: GET_PROFILING_TAGS,
});

export const getProfilingTagsSuccess = (payload) => ({
  type: GET_PROFILING_TAGS_SUCCESS,
  payload: payload,
});

export const getProfilingTagsError = (error) => ({
  type: GET_PROFILING_TAGS_ERROR,
  payload: error,
});

export const getAggrTagsData = (payload) => ({
  type: GET_AGGR_TAGS_DATA,
  payload: payload
});

export const getAggrTagsDataSuccess = (payload) => ({
  type: GET_AGGR_TAGS_DATA_SUCCESS,
  payload: payload,
});

export const getAggrGroupByTagsDataSuccess = (payload) => ({
  type: GET_AGGR_GROUP_BY_TAGS_DATA_SUCCESS,
  payload: payload
})

export const getAggrTagsDataError = (error) => ({
  type: GET_AGGR_TAGS_DATA_ERROR,
  payload: error,
});

export const getApiTimingsData = (payload) => ({
  type: GET_API_TIMINGS_DATA,
  payload: payload
});

export const getApiTimingsDataSuccess = (payload, meta = {}) => ({
  type: GET_API_TIMINGS_DATA_SUCCESS,
  payload: payload,
  meta,
});

export const getApiTimingsDataError = (error) => ({
  type: GET_API_TIMINGS_DATA_ERROR,
  payload: error,
});

export const exportApiTimingsData = (queryParams) => ({
  type: EXPORT_API_TIMINGS_DATA,
  payload: { queryParams },
});

export const exportApiTimingsDataSuccess = () => ({
  type: EXPORT_API_TIMINGS_DATA_SUCCESS,
});

export const exportApiTimingsDataError = (error) => ({
  type: EXPORT_API_TIMINGS_DATA_ERROR,
  payload: error,
});

export const getApiDataById = (payload) => ({
  type: GET_API_DATA_BY_ID,
  payload: payload
});

export const getApiDataByIdSuccess = (payload) => ({
  type: GET_API_DATA_BY_ID_SUCCESS,
  payload: payload,
});

export const getApiDataByIdError = (error) => ({
  type: GET_API_DATA_BY_ID_ERROR,
  payload: error,
});

// DMS specific


export const getDmsLogsStreams = () => ({
  type: GET_DMS_LOGS_STREAMS,
});

export const getDmsLogsStreamsSuccess = (payload) => ({
  type: GET_DMS_LOGS_STREAMS_SUCCESS,
  payload: payload,
});

export const getDmsLogsStreamsError = (error) => ({
  type: GET_DMS_LOGS_STREAMS_ERROR,
  payload: error,
});

export const getDmsStatsData = (payload) => ({
  type: GET_DMS_STATS_DATA,
  payload: payload
});

export const getDmsStatsDataSuccess = (payload) => ({
  type: GET_DMS_STATS_DATA_SUCCESS,
  payload: payload,
});

export const getDmsStatsDataError = (error) => ({
  type: GET_DMS_STATS_DATA_ERROR,
  payload: error,
});


export const getDmsLogsData = (payload) => ({
  type: GET_DMS_LOGS_DATA,
  payload: payload
});

export const getDmsLogsDataSuccess = (payload) => ({
  type: GET_DMS_LOGS_DATA_SUCCESS,
  payload: payload,
});

export const getDmsLogsDataError = (error) => ({
  type: GET_DMS_LOGS_DATA_ERROR,
  payload: error,
});

export const getProductsNames = (payload) => ({
  type: GET_PRODUCTS_NAMES,
  payload: payload
});

export const getProductsNamesSuccess = (payload) => ({
  type: GET_PRODUCTS_NAMES_SUCCESS,
  payload: payload,
});

export const getProductsNamesError = (error) => ({
  type: GET_PRODUCTS_NAMES_ERROR,
  payload: error,
});

export const getRuleStats = (payload) => ({
  type: GET_RULE_STATS,
  payload: payload
});

export const getRuleStatsSuccess = (payload) => ({
  type: GET_RULE_STATS_SUCCESS,
  payload: payload,
});

export const getRuleStatsError = (error) => ({
  type: GET_RULE_STATS_ERROR,
  payload: error,
});

export const getRuleNames = (payload) => ({
  type: GET_RULE_NAMES,
  payload: payload
});

export const getRuleNamesSuccess = (payload) => ({
  type: GET_RULE_NAMES_SUCCESS,
  payload: payload,
});

export const getRuleNamesError = (error) => ({
  type: GET_RULE_NAMES_ERROR,
  payload: error,
});

export const getAccountsList = (payload) => ({
  type: GET_ACCOUNTS_LIST,
  payload: payload
});

export const getAccountsListSuccess = (payload) => ({
  type: GET_ACCOUNTS_LIST_SUCCESS,
  payload: payload,
});

export const getAccountsListError = (error) => ({
  type: GET_ACCOUNTS_LIST_ERROR,
  payload: error,
});

export const getRuleLogs = (payload) => ({
  type: GET_RULE_LOGS,
  payload: payload
});

export const getRuleLogsSuccess = (payload) => ({
  type: GET_RULE_LOGS_SUCCESS,
  payload: payload,
});

export const getRuleLogsError = (error) => ({
  type: GET_RULE_LOGS_ERROR,
  payload: error,
});

export const getRuleLogDetails = (payload) => ({
  type: GET_RULE_LOG_DETAILS,
  payload: payload
});

export const getRuleLogDetailsSuccess = (payload) => ({
  type: GET_RULE_LOG_DETAILS_SUCCESS,
  payload: payload,
});

export const getRuleLogDetailsError = (error) => ({
  type: GET_RULE_LOG_DETAILS_ERROR,
  payload: error,
});
